/**
 * @flow
 */

// CSS class name constants are not translatable strings.
/* eslint-disable i18next/no-literal-string */
export const buttonTypeMap = {
  default: "",
  primary: "is-primary",
  dark: "is-dark",
  info: "is-info",
  success: "is-success",
  warning: "is-warning",
  danger: "is-danger",
  light: "is-light",
  text: "is-text",
  "ghost-primary": "is-ghost",
  tertiary: "is-tertiary",
};

export type ButtonType = $Keys<typeof buttonTypeMap>;
